import { get, post, postSingle } from '@/plugins/axios'

// 登录
export const loginAsync = (params) => post('/access/api/v1/login', params)
// 获取用户中心数据
export const getAccountCenterAsync = (params) => get('/access/api/v1/user/center', { params })
// 平台key
export const getPlatformAppkeyAsync = (params) => get(`/access/api/v1/platforms/data/${params.appKey}`, { params })
// 菜单按钮权限
export const getMenuAuthAsync = (params) => get(`/access/api/v1/menus/auth/${params.appKey}`, params)
// 退出
export const logoutAsync = (params) => get('/access/api/v1/idassLogout', params)

// 导出表格数据
// export const exportDataAsync = (params) => post(base + '/api/exportData', params, { responseType: 'blob' })

